module.exports = __webpack_public_path__ + "static/67-ce48c1c547a5ab1b7ca7bac3b49514a6.png";